export const secondsToHms = d => {
  const date = new Date(null)
  date.setSeconds(d)
  return date.toISOString().substring(11, 19)
}

// Calculate size unit in viewport units using 1920x1080 for reference
export const getSize = sizeInPx => {
  const round = number => Math.round((number + Number.EPSILON) * 100) / 100
  const isVertical = window.screen.height > window.screen.width
  const width = 1920

  return isVertical ? `${round((sizeInPx / width) * 100)}vh` : `${round((sizeInPx / width) * 100)}vw`
}

export const chunkArray = (array, chunkSize) => {
  let result = []
  for (let i = 0; i < array.length; i += chunkSize) {
    result = [...result, array.slice(i, i + chunkSize)]
  }

  return result
}

export const getTBDField = field => (!field || field.trim().toLowerCase() === 'none' ? 'TBD' : field)
